import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-154abb39"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 3 }
const _hoisted_12 = { key: 4 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 规格图片 ", -1))
const _hoisted_16 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_17 = { style: {"width":"100% !important"} }
const _hoisted_18 = { style: {"width":"100%","height":"100%","text-align":"center","background-color":"#fff"} }
const _hoisted_19 = ["href"]
const _hoisted_20 = ["src"]
const _hoisted_21 = { style: {"width":"100%","text-align":"center","font-weight":"900"} }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"20px"} }, null, -1))
const _hoisted_23 = { style: {"clear":"both"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_product_menu = _resolveComponent("product-menu")!
  const _component_miezz_page_list = _resolveComponent("miezz-page-list")!
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_miezz_button_bar = _resolveComponent("miezz-button-bar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_product_menu),
    _createVNode(_component_miezz_page_list, {
      modelValue: _ctx.list,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.list) = $event)),
      onHandleGet: _ctx.handleGet,
      onHandleTopButtonClick: _ctx.handleTopButtonClick,
      onHandleRowButtonClick: _ctx.handleRowButtonClick,
      onHandleBottomButtonClick: _ctx.handleBottomButtonClick
    }, {
      "column-header": _withCtx(({ model }) => [
        (model.Prop == 'StockQuantity')
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(model.Label) + "（" + _toDisplayString(_ctx.product.Data.ChargeUnithZh) + "） ", 1))
          : _createCommentVNode("", true)
      ]),
      column: _withCtx(({ model, row }) => [
        (model.Prop == 'SpecImages')
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
              (row.SpecImages!=null && row.SpecImages!=undefined && row.SpecImages.length>0)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    style: {"cursor":"pointer","color":"#fe995b","font-weight":"900"},
                    onClick: ($event: any) => (_ctx.onImage(row))
                  }, " 查看 ", 8, _hoisted_3))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, "暂无数据"))
            ]))
          : _createCommentVNode("", true),
        (model.Prop == 'NumberString')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (row.NumberString)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(row.NumberString), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, "暂无数据"))
            ]))
          : _createCommentVNode("", true),
        (model.Prop == 'Weight')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (row.Weight)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(row.Weight), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_10, "暂无数据"))
            ]))
          : _createCommentVNode("", true),
        (model.Prop == 'StockQuantity')
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(row.StockQuantity), 1))
          : _createCommentVNode("", true),
        (model.Prop == 'SysRemark')
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (row.SysRemark)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(row.SysRemark), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_14, "暂无数据"))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "onHandleGet", "onHandleTopButtonClick", "onHandleRowButtonClick", "onHandleBottomButtonClick"]),
    (_ctx.imageForm != undefined)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          modelValue: _ctx.imageForm.Visiable,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.imageForm.Visiable) = $event)),
          "show-close": false,
          style: {"width":"50%"},
          top: "30px",
          "close-on-click-modal": false,
          "close-on-press-escape": false,
          "append-to-body": true
        }, {
          header: _withCtx(({ close }) => [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_el_icon, {
                style: {"cursor":"pointer"},
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_el_carousel, {
                interval: 5000,
                arrow: "hover"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageForm.Rows, (p, index) => {
                    return (_openBlock(), _createBlock(_component_el_carousel_item, { key: index }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("a", {
                            href: p.Url,
                            target: "_blank"
                          }, [
                            _createElementVNode("img", {
                              style: {"height":"85%"},
                              src: p.Url
                            }, null, 8, _hoisted_20)
                          ], 8, _hoisted_19),
                          _createElementVNode("div", _hoisted_21, _toDisplayString(p.Name), 1)
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_miezz_button_bar, {
                modelValue: _ctx.bottomButtonsImage,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.bottomButtonsImage) = $event)),
                isBackground: true,
                onHandleClick: _ctx.handleClickImage
              }, null, 8, ["modelValue", "onHandleClick"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}